import Card from "@material-ui/core/Card/Card";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { parse } from "query-string";
import * as React from "react";
import { Content } from "../components/content";
import { DocumentActionList } from "../components/document-action-list";
import { DocumentMetadataDisplay } from "../components/document-metadata-display";
import { SanitisedHtml } from "../components/html";
import { BlockQuote } from "../components/material/block-quote";
import { TagList, Spacer } from "../components/utility-components";
import { withAuthContext } from "../components/with-auth-context";
import { withSnackbar } from "../components/with-snackbar";
import { DocumentPublishModel } from "../model/autogen/DocumentPublishModel";
import { PeopleRequestFactory } from "../model/autogen/PeopleController";
import { PersonModel } from "../model/autogen/PersonModel";
import { UserLevel } from "../model/autogen/UserLevel";
import { ItemPageProps } from "./debate-note-item-page";
import { PersonEditRoute } from "../route-paths";
import { QuoteRequestFactory } from "../model/autogen/QuoteController";
import { QuoteModel } from "../model/autogen/QuoteModel";
// import { DisplayTweet } from "components/material/display-tweet";
// import { TweetModel } from "model/autogen/TweetModel";
// import { TweetRequestFactory } from "model/autogen/TweetController";
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from "@material-ui/core";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Iif } from "components/iif";
import { PersonType_DISPLAY_NAMES } from "../model/autogen/PersonType";
export interface IPersonPageState {
    model: PersonModel | undefined;
    quotedIn: QuoteModel[];
    // tweets: TweetModel[];
}

function quoteSortComparator(a: QuoteModel, b: QuoteModel) {
    const aDateStr = `${a.dateOfQuote}`;
    const bDateStr = `${b.dateOfQuote}`;
    const retVal = aDateStr.localeCompare(bDateStr);
    if (retVal > 0) {
        return -1;
    } else if (retVal < 0) {
        return 1;
    }
    return 0;
}

// function tweetSortComparator(a: TweetModel, b: TweetModel) {
//     const aDateStr = `${a.dateOfTweet}`;
//     const bDateStr = `${b.dateOfTweet}`;
//     const retVal = aDateStr.localeCompare(bDateStr);
//     if (retVal > 0) {
//         return -1;
//     } else if (retVal < 0) {
//         return 1;
//     }
//     return 0;
// }

class PersonItemPageComponent extends React.Component<ItemPageProps, IPersonPageState> {
    constructor(props: ItemPageProps) {
        super(props);
        this.state = { model: undefined, quotedIn: [], /*tweets: []*/ };
    }
    public async componentDidMount() {
        this.loadContent();
    }
    public componentDidUpdate(prevProps: ItemPageProps) {
        if (prevProps.match.params.id != this.props.match.params.id) {
            this.loadContent();
        }
    }
    private shouldIncludeDeleted(): boolean {
        const { includeDeleted } = parse(this.props.location.search);
        return this.props.user.level >= UserLevel.Editor && (!!includeDeleted == true);
    }
    private loadContent = async () => {
        const id = parseInt(this.props.match.params.id, 10);
        let model;
        try { 
            const result = await this.props.callApi((fetcher) => PeopleRequestFactory.getById(fetcher, id, this.shouldIncludeDeleted()));
            if (result) {
                model = result
            }
        } catch (e) {
            window.location.href = '/page-not-found';
        }
        const quotedIn = await this.props.callApi((fetcher) => QuoteRequestFactory.getQuotes(fetcher, id));
        //const tweets = await this.props.callApi((fetcher) => TweetRequestFactory.getTweets(fetcher, id)) 
        this.setState({ model, quotedIn, /*tweets*/ });
    }
    private onPublishContent = async () => {
        if (this.state.model && confirm("Are you sure you want to publish this content?")) {
            this.props.showSnackbarMessage("Publishing content ...");
            const payload = {
                documentId: this.state.model.id
            } as DocumentPublishModel;
            const model = await this.props.callApi((fetcher) => PeopleRequestFactory.publish(fetcher, payload));
            this.props.showSnackbarMessage("Content published");
            this.setState({ model });
        }
    }
    private onDelete = async (e: any) => {
        const { model } = this.state;
        if (model && confirm("Are you sure you want to archive this content?")) {
            this.props.showSnackbarMessage("Archiving content ...");
            try {
                const result = await this.props.callApi((fetcher) => PeopleRequestFactory.delete(fetcher, model.id));
                if (result) {
                    this.props.showSnackbarMessage("Content archived");
                    this.props.history.goBack();
                }
            } catch (e) {
                this.props.showSnackbarMessage(`Failed to archived content: ${e}`);
            }
        }
    }

    public render() {
        const { model, quotedIn, /*tweets*/ } = this.state;
        if (!model) {
            return <LinearProgress />;
        }
        const recentQuotes = model.quotes.length > 0 ? model.quotes.sort(quoteSortComparator).slice(0, 5) : []

        const recentQuotedIn = quotedIn.length > 0 ? quotedIn.sort(quoteSortComparator).slice(0, 5) : []

        //const recentTweets = tweets.length > 0 ? tweets.sort(tweetSortComparator).slice(0, 5) : []

        const personTypeLabels = PersonType_DISPLAY_NAMES;

        const showQuotes = recentQuotes.length > 0 || recentQuotedIn.length > 0;

        return <Content>
            <h1>{model.title}</h1>
            <DocumentMetadataDisplay model={model} />
            <Card>
                <Content>
                    <article>
                        <h3>{model.firstName + " " + model.lastName}</h3>
                    </article>
                    <article>
                        <h3>Type</h3>
                        <SanitisedHtml html={personTypeLabels[model.personType]} />
                    </article>
                    <article>
                        <h3>Party Affiliation</h3>
                        <SanitisedHtml html={model.partyAffiliation || "<not specified>"} />
                    </article>
                    <article>
                        <h3>Facebook</h3>
                        <SanitisedHtml html={model.facebook} />
                    </article>
                    <article>
                        <h3>Twitter</h3>
                        {model.twitterHandles.length > 0 && <SanitisedHtml html={`@${model.twitterHandles[0].displayName}`} />}
                    </article>
                    <Spacer />
                    <Iif show={showQuotes}> 
                        <div style={{ padding: '10px' }}>
                            <ExpansionPanel style={{ backgroundColor: "#fbfbfb" }}>
                                <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                                    <h3>Quotes</h3>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <div style={{ width: "100%" }}>
                                        <Iif show={recentQuotes.length > 0}>
                                            <article>
                                                <h5>Recent Transcripts</h5>
                                                {recentQuotes.map((x, i) => {
                                                    return <BlockQuote key={i} quote={x} />
                                                })}
                                            </article>
                                        </Iif>
                                        <Spacer />
                                        <Iif show={recentQuotedIn.length > 0}>
                                            <article>
                                                <h5>Referred to in Transcript</h5>
                                                {recentQuotedIn.map((x, i) => {
                                                    return <BlockQuote key={i} quote={x} author={model} />
                                                })}
                                            </article>
                                        </Iif>
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    </Iif>
                    {/* <Iif show={recentTweets.length > 0}>                 
                        <article>
                            <h3>Recent Tweets</h3>
                            {recentTweets.map((tw, i) => {
                                return <DisplayTweet initiallyExpanded={false} tweet={tw} key={i} />
                            })}
                        </article>
                    </Iif> */}
                    <TagList tags={model.tags} />
                </Content>
            </Card>
            <DocumentActionList editRoute={PersonEditRoute(model.id)} model={model} user={this.props.user} onDelete={this.onDelete} onPublishContent={this.onPublishContent} />
        </Content>;
    }
}

export const PersonItemPage = withSnackbar(withAuthContext(PersonItemPageComponent) as any);


// WEBPACK FOOTER //
// ./src/pages/person-item-page.tsx